import datepicker from "js-datepicker";

export default class Form {
    constructor() {
        this.elements = {
            inputs: document.querySelectorAll(
                'input:not([type="date"]):not([type="radio"]):not([type="checkbox"]):not([type="submit"]), select, textarea'
            ),
            dateInputs: document.querySelectorAll('input[type="date"]')
        };

        if (!this.elements.inputs.length && !this.elements.dateInputs.length) {
            return;
        }

        this.settings = {
            class: "is--filled-or-focused"
        };

        if (this.elements.dateInputs.length) {
            this.setDatepickers();
        }

        this.onLoad();
        this._setDOMReferences();
    }

    _setDOMReferences() {
        for (let i = 0; i < this.elements.inputs.length; i++) {
            const input = this.elements.inputs[i];
            input.addEventListener("focus", () => this.onFocus(input));
            input.addEventListener("blur", () => this.onBlur(input));
            input.addEventListener("change", () => this.onChange(input));
        }
    }

    onLoad() {
        for (let i = 0; i < this.elements.inputs.length; i++) {
            const input = this.elements.inputs[i];
            const fieldElem = this._findAncestor(input, "field");
            const inputValue = input.value;

            if (input.disabled) {
                const fieldLabel = fieldElem.querySelector("label");
                fieldLabel.classList.add("is--disabled");
            }

            if (inputValue && fieldElem) {
                fieldElem.classList.add(this.settings.class);
            }
        }

        for (let i = 0; i < this.elements.dateInputs.length; i++) {
            const input = this.elements.dateInputs[i];
            const fieldElem = this._findAncestor(input, "field");
            const inputValue = input.value;

            if (input.disabled) {
                const fieldLabel = fieldElem.querySelector("label");
                fieldLabel.classList.add("is--disabled");
            }

            if (inputValue && fieldElem) {
                input.classList.add("has--value");
                fieldElem.classList.add(this.settings.class);
            }
        }
    }

    onFocus(input) {
        const fieldElem = this._findAncestor(input, "field");

        if (fieldElem) {
            fieldElem.classList.add(this.settings.class);
        }
    }

    onBlur(input) {
        const fieldElem = this._findAncestor(input, "field");
        const inputValue = input.value;

        if (!inputValue && fieldElem) {
            fieldElem.classList.remove(this.settings.class);
        }
    }

    onChange(input) {}

    setDatepickers() {
        for (let i = 0; i < this.elements.dateInputs.length; i++) {
            const inputElem = this.elements.dateInputs[i];

            datepicker(inputElem, {
                startDay: 1,
                customDays: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
                customMonths: [
                    "januari",
                    "februari",
                    "maart",
                    "april",
                    "mei",
                    "juni",
                    "juli",
                    "augustus",
                    "september",
                    "oktober",
                    "november",
                    "december"
                ],
                customOverlayMonths: [
                    "jan",
                    "feb",
                    "mrt",
                    "apr",
                    "mei",
                    "jun",
                    "jul",
                    "aug",
                    "sep",
                    "okt",
                    "nov",
                    "dec"
                ],
                overlayButton: "Opslaan",
                overlayPlaceholder: "4-cijfer jaartal",
                disableMobile: true,
                formatter: (input, date, instance) => {
                    let month = "" + (date.getMonth() + 1);
                    let day = "" + date.getDate();
                    const year = date.getFullYear();

                    if (month.length < 2) {
                        month = "0" + month;
                    }
                    if (day.length < 2) {
                        day = "0" + day;
                    }

                    input.value = [year, month, day].join("-"); // => 'YYYY-MM-DD'
                },
                onShow: instance => {
                    instance.parent.classList.add(this.settings.class);
                },
                onHide: instance => {
                    if (instance.el.value) {
                        instance.el.classList.add("has--value");
                    } else {
                        instance.el.classList.remove("has--value");
                        instance.parent.classList.remove(this.settings.class);
                    }
                }
            });
        }
    }

    _findAncestor(el, cls) {
        while ((el = el.parentElement) && !el.classList.contains(cls));
        return el;
    }
}
